import * as actionTypes from './actionTypes';

export const toggleUpdateAnnouncement=()=>({
    type:actionTypes.TOGGLE_ANNOUNCEMENT_UPDATE
})